import React, { useEffect } from "react";
import { Grid2 } from "@mui/material";
import { fetchVehiclesCategories, useAppDispatch, useAppSelector } from "@redux";
import { setVehiclesCategory, updateSnackBar } from "@redux";
import { fetchVehiclesData, selectVehicle } from "@redux";

import { TitleMenuComponent, AppInput, PassChangeButton } from "..";
import { StyledVehicleView, VehiclesListItemComponent, VehiclesCatetoryComponent } from ".";
import { appRouteEnums, menuTitleEnums } from "@enums";
import { SearchIcon } from "@assets";
import { categoriesApi} from "@api";
import { useWindowDimensions, useAppNavigation } from "@utils";
import { API_CATEGORY_TYPE_VEHICLE } from "@configs";
import { useHistory, useLocation } from "react-router-dom";
import mobile_arrow_left from "@assets/Icons/arrow/mobile_arrow_left.svg";

export const VehiclesView = () => {
  // redux state
  // component state

  const [selectedIndex, setSelectedIndex] = React.useState(-1);
  const [category, setCategory] = React.useState<string>("");
  //const [categories, setCategories] = React.useState<Array<any>>();
  //const [loading, setLoading] = React.useState<boolean>(false);
  //const [listProducts, setListProducts] = React.useState<any>();
  const messagesEndRef = React.useRef<any>(null);
  const [categoryViewMobile, setCategoryViewMobile] = React.useState<boolean>(true);
  // hooks
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();

  //URLでフィルター完結させるために追加
  const categoryId = query.get("categoryId");
  const subCategoryId = query.get("subCategoryId");
  const keywordFromUrl = query.get("keyword") || "";
  const [inputValue, setInputValue] = React.useState<string>(keywordFromUrl || "");

  const dispatch = useAppDispatch();
  const width = useWindowDimensions().width;
  const history = useHistory();
  const { navigateWithState } = useAppNavigation();

  const vehicleState = useAppSelector(selectVehicle);
  // const dataResult = useAppSelector((state) => state.vehicle.dataResult);
  //  const vehicleCategoryId = dataResult?.categoryId;
  // const vehicleSubCategoryId = dataResult?.subCategoryId;

  useEffect(() => {
    if (!vehicleState) {
      dispatch(fetchVehiclesData() as any);
      dispatch(fetchVehiclesCategories() as any);
    }
  }, [dispatch, vehicleState]);

  //キーワード検索
  useEffect(() => {
    setInputValue(keywordFromUrl);
  }, [keywordFromUrl]);

  //カレンダーページで利用するため値更新
  useEffect(() => {
    dispatch(setVehiclesCategory({
      categoryId: categoryId,
      subCategoryId: subCategoryId,
    }));
  }, [categoryId, subCategoryId, keywordFromUrl]);

  const fullVehicleArray = vehicleState?.categories?.data || [];

  const vehicleArray = fullVehicleArray;

  // const vehicleArray = vehicleSubCategoryId ? fullVehicleArray.filter(vehicle => vehicle.categoryId === vehicleSubCategoryId) : fullVehicleArray;
  const vehicleCategoryArray = vehicleState?.vehicleCategories || [];

  // events
  //what: events
  const handleOnChange = (value: string) => {
    setInputValue(value || "");
  };
  //What: scroll to bottom to view data results when device is mobile
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // URLクエリ -> UI同期（カテゴリ展開状態）
  useEffect(() => {
    // クエリがなければ展開をすべて閉じる
    if (!categoryId && !subCategoryId) {
      setSelectedIndex(-1);
      return;
    }
    // categoryId がある場合は対応する親カテゴリを展開
    if (categoryId && vehicleCategoryArray?.length) {
      const parentIndex = vehicleCategoryArray.findIndex((c: any) => String(c.id) === String(categoryId));
      if (parentIndex >= 0) setSelectedIndex(parentIndex);
    }
  }, [categoryId, subCategoryId, vehicleCategoryArray]);

  //URLでフィルター完結させるために追加
  const handleOnSearchSubmit = () => {
    const params = new URLSearchParams(location.search);
    if (categoryId) params.set("categoryId", categoryId);
    setCategoryViewMobile(false);
    setSelectedIndex(-1);
    if (width < 768) {
      scrollToBottom();
    }
    params.set("keyword", inputValue);
    history.push(`/vehicles?${params.toString()}`);
  };

  //what: call api after re-render
  //how: when sub category id is updated, this page is re-render
  //React.useEffect(() => {
  //  fetchListProducts({
  //    category,
  //  });
  //}, [category]);
  // call api get categories
  React.useEffect(() => {
    const fetchCategoriesApi = async () => {
      try {
        /*const response = */await categoriesApi.getCategories({
        type: API_CATEGORY_TYPE_VEHICLE,
      });
        //setCategories(response.data.data);
      } catch (err: any) {
        dispatch(
          updateSnackBar({
            messageType: "error",
            message: err.response.data.message,
          })
        );
      }
    };
    fetchCategoriesApi();
  }, []);

  //what: select a subCategory ID
  // console.log("search words", inputValue);

  // URLでフィルター管理（autoモード: 初回はpushで履歴を追加、それ以降はreplaceで置換）
  const handleSelectCategory = (subCategory, parentCategoryId) => {
    setCategoryViewMobile(false);
    setCategory(parentCategoryId);
    const query = keywordFromUrl ? { keyword: keywordFromUrl } : {};
    // 'from' は渡さない（navigateWithStateは与えたparamのみでURLを構築する）
    navigateWithState(
      "/vehicles",
      { categoryId: parentCategoryId, subCategoryId: subCategory.id, ...query },
      "auto"
    );
  };

  //大カテゴリクリックはトグルのみに限定
  const handleClick = (index: number) => {
    setSelectedIndex(selectedIndex === index ? -1 : index);
  };


  //URLでフィルター完結させるために追加
  const filteredVehicles = vehicleArray
    .filter(vehicle => !subCategoryId || Number(vehicle.categoryId) === Number(subCategoryId))
    // .filter(vehicle => !subCategoryId || Number(vehicle.categoryId) === Number(subCategoryId))
    .filter(vehicle => !keywordFromUrl || vehicle.name.toLowerCase().includes(keywordFromUrl.toLowerCase()));


  const inputValueMatchCount = inputValue ? filteredVehicles.length : undefined;

  //フィルターリセット
  const handleClearFilters = () => {
    // Reset UI states as well as query parameters
    setInputValue("");
    setSelectedIndex(-1);
    setCategory("");
    setCategoryViewMobile(true);

    const params = new URLSearchParams(location.search);
    params.delete("categoryId");
    params.delete("subCategoryId");
    params.delete("keyword");

    const remainingQueryString = params.toString();
    history.push(remainingQueryString ? `/vehicles?${remainingQueryString}` : "/vehicles");
  };


  return (
    <StyledVehicleView>
      {/* <AppTopBar /> */}
      <div className="vehicles">
        <div className="vehicles__top">
          {/* <div
            className="newOT__top-icon"
            onClick={() => history.push(appRouteEnums.PATH_HOME)}
          >
            <AppIconButton icon={<img src={mobile_arrow_left} alt="icon" />} />
          </div> */}
          <Grid2 container spacing={4} alignItems={"center"}>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <div>
                <TitleMenuComponent text={menuTitleEnums.TITLE_VEHICLES} />
              </div>
              {(categoryId || keywordFromUrl) && (
                <PassChangeButton onClick={handleClearFilters}>
                  フィルターリセット
                </PassChangeButton>
              )}

            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
              <PassChangeButton onClick={() => history.push({
                pathname: appRouteEnums.PATH_VEHICLES_BORROWING_CALENDAR,
                state: { searchWord: inputValue }
              })}>カレンダー表示</PassChangeButton>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>

              <div className="vehicles__top-searchForm" style={{ flexDirection: "column" }}>
                <AppInput
                  value={inputValue}
                  iconStart={<SearchIcon />}
                  handleChange={handleOnChange}
                  placeholder="車両名"
                  disabled={false}
                  name="searchValue"
                  onClick={handleOnSearchSubmit}
                />
                {inputValueMatchCount !== undefined ? <span style={{ fontSize: "0.8em", color: "#666", padding: "0.5rem 2rem" }}>一致数: {inputValueMatchCount}</span> : null}
              </div>
            </Grid2>
          </Grid2>
        </div>
        <div className="vehicles__content visible-pc">
          <Grid2 container>
            <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
              <div className="category">
                {vehicleCategoryArray &&
                  vehicleCategoryArray?.map((category, index) => (
                    <div key={category.id}>
                      <VehiclesCatetoryComponent
                        category={category}
                        checked={
                          String(categoryId) === String(category.id) ||
                          index === selectedIndex
                        }
                        onClick={() => {
                          handleClick(index);
                        }}
                        handleSelectSubCategory={handleSelectCategory}
                      />
                    </div>
                  ))}
              </div>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 9, lg: 9 }}>
              <div className="listItem" ref={messagesEndRef}>
                <VehiclesListItemComponent
                  loading={false}
                  products={filteredVehicles}
                  categoryId={category}
                />
              </div>
            </Grid2>
          </Grid2>
        </div>
        <div className="vehicles__content visible-mobile">
          {categoryViewMobile ? (
            <div className="category">
              {vehicleCategoryArray &&
                vehicleCategoryArray?.map((category, index) => (
                  <div key={category.id}>
                    <div key={category.id}>
                      <VehiclesCatetoryComponent
                        category={category}
                        checked={
                          String(categoryId) === String(category.id) ||
                          index === selectedIndex
                        }
                        onClick={() => {
                          handleClick(index);
                        }}
                        handleSelectSubCategory={handleSelectCategory}
                      />
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div>
              <div
                style={{ width: "100%", textAlign: "left", padding: "2rem 0" }}
                onClick={() => setCategoryViewMobile(true)}
              >
                <img src={mobile_arrow_left} alt="icon" />
              </div>
              <VehiclesListItemComponent
                loading={false}
                products={filteredVehicles}
                categoryId={category}
              />
            </div>
          )}
        </div>
      </div>
    </StyledVehicleView>
  );
};
